import { useEffect, type ReactElement, type ReactNode, useState } from "react"
import { useSelector } from "react-redux";
import { RootState } from "src/app/store";
import DealerDetailCard from "./DealerDetailCard";
import EndUserLocationChart from "./EndUserLocationChart";
import ExceptionEventCard from "./ExceptionEventCard";

export interface DashboardMainProps {
        children?: ReactNode
}

export default function DashboardMain(props: DashboardMainProps): ReactElement {

        const { dealerDetail, dealerDetailLoading } = useSelector((state: RootState) => state.dealerDetail);
        const [onlinePercentage, setOnlinePercentage] = useState<number>(0);


        useEffect(() => {
                const percentage = (dealerDetail.TotalNumberOfLocationsOnline / dealerDetail.TotalNumberOfLocations) * 100;
                setOnlinePercentage(Math.round(percentage));
        }, [dealerDetail])

        return <>
                <div className="grid grid-rows-1fr gap-2 h-[inherit]">
                        <div className="flex h-full min-h-0 gap-4">
                                <div className="flex flex-col gap-4 h-full w-full">
                                        <div className="bg-blue-400 rounded-xs shadow-[4px_4px_10px_rgba(0,0,0,0.25)] place-content-between w-full h-full flex gap-4 p-2">
                                                <EndUserLocationChart value={onlinePercentage} target={100} />
                                        </div>
                                        <div className="bg-blue-400 rounded-xs shadow-[4px_4px_10px_rgba(0,0,0,0.25)] place-content-between w-full h-full flex gap-4 p-2">
                                                <DealerDetailCard />
                                        </div>
                                </div>
                                <div className="flex flex-col w-full h-full">
                                        <div className="bg-blue-400 rounded-xs shadow-[4px_4px_10px_rgba(0,0,0,0.25)] overflow-auto w-full h-full flex flex-col p-2">
                                                <ExceptionEventCard />
                                        </div>
                                </div>
                        </div>
                </div>
        </>
}
